import { useEffect } from "react";
import { clearUserCache, removeLocal } from "../utils/storageHelper";

/**
 * Hook to clear sensitive localStorage data when tab/browser is closed
 * Uses beforeunload and pagehide events for maximum compatibility
 */
export const useCleanupOnUnload = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log("[Cleanup] Clearing localStorage on tab close");
      // Clear all user-related cache
      clearUserCache();
      // Clear profile-specific data
      removeLocal("discovery_profile");
      removeLocal("user_profile");
      removeLocal("user_matches");
      removeLocal("active_match_id");
      removeLocal("chat_messages");
      // Clear any temp/session data
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (
          key.includes("cache_") ||
          key.includes("temp_") ||
          key.includes("session_")
        ) {
          removeLocal(key);
        }
      });
    };

    // Use both events for maximum browser compatibility
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handleBeforeUnload);

    return () => {
      // Cleanup event listeners
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pagehide", handleBeforeUnload);
    };
  }, []);
};
